import type { Component, JSX } from "solid-js";
import { Navigate } from "@solidjs/router";
import { getToken } from "../lib/auth";
import { useIdleLogout } from "./idleTimer";

interface ProtectedProps {
  children?: JSX.Element;
}

const Protected: Component<ProtectedProps> = (props) => {
  const token = getToken();
  const isIdle = useIdleLogout();
  if (!token || isIdle()) {
    return <Navigate href="/login" />;
  }
  return props.children || null;
};

export default Protected;
